import { useState } from 'react';
import { trocarMinhaSenha } from '../../acesso';
import type { Sessao } from '../../auth';
import { Icone } from '../../design/Icone';
import { mensagemDeFalha } from '../equipe/Equipe';
import './conta.css';
import { propsDeSenhaQueNaoSalva } from '../../design/semSalvarSenha';

/**
 * CRIE SUA SENHA (dono, 29/09): quem entrou com a SENHA PROVISÓRIA dada pelo administrador cai
 * aqui antes de qualquer tela. O servidor já segura: até trocar, a sessão não tem capacidade
 * nenhuma. Trocada, a pessoa segue normalmente — e o admin nunca soube a senha nova.
 */
export function CrieSuaSenha({
  sessao,
  nome,
  aoSair,
}: {
  sessao: Sessao;
  nome: string;
  aoSair: () => void;
}) {
  const [provisoria, setProvisoria] = useState('');
  const [nova, setNova] = useState('');
  const [confirma, setConfirma] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const diferente = confirma.length > 0 && nova !== confirma;
  const pronto = provisoria.length > 0 && nova.length >= 6 && nova === confirma;
  return (
    <main className="cs">
      <section className="cs-cartao" aria-label="Crie sua senha">
        <img src="/img/inovapay-logo.png" alt="InovaPay" className="cs-logo" />
        <h1>Crie sua senha</h1>
        <p>
          Olá{nome ? `, ${nome.split(' ')[0] ?? ''}` : ''}! Você entrou com uma senha provisória.
          Crie agora a sua senha — só você vai saber.
        </p>
        <label className="cs-campo">
          <span>Senha provisória (a que você recebeu)</span>
          <input
            {...propsDeSenhaQueNaoSalva()}
            value={provisoria}
            onChange={(e) => setProvisoria(e.target.value)}
            autoFocus
          />
        </label>
        <label className="cs-campo">
          <span>Nova senha (mínimo 6 caracteres)</span>
          <input
            {...propsDeSenhaQueNaoSalva()}
            value={nova}
            onChange={(e) => setNova(e.target.value)}
          />
        </label>
        <label className="cs-campo">
          <span>Repita a nova senha</span>
          <input
            {...propsDeSenhaQueNaoSalva()}
            value={confirma}
            onChange={(e) => setConfirma(e.target.value)}
          />
        </label>
        {diferente && <p className="cs-erro">As duas senhas novas não são iguais.</p>}
        {erro && (
          <p className="cs-erro" role="alert">
            {erro}
          </p>
        )}
        <button
          type="button"
          className="cs-botao"
          disabled={!pronto || enviando}
          onClick={() => {
            setEnviando(true);
            setErro(null);
            void trocarMinhaSenha(sessao, provisoria, nova).then((r) => {
              setEnviando(false);
              if (r.ok) window.location.reload();
              else setErro(mensagemDeFalha(r.falha));
            });
          }}
        >
          <Icone nome="key" tamanho={15} traco={1.8} />{' '}
          {enviando ? 'Salvando…' : 'Criar minha senha'}
        </button>
        <button type="button" className="cs-sair" onClick={aoSair}>
          Sair
        </button>
      </section>
    </main>
  );
}
